module.exports = "/_next/static/images/02d931683c95bcc9ef549c87dc092c49-man-with-cellphone-md@1x.jpg.webp";